import React from "react";

interface DocxIconProps {
  className?: string;
}

export function DocxIcon({ className = "w-5 h-5" }: DocxIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Add your DOCX SVG code here */}
      <rect x="4" y="2" width="16" height="20" rx="2" fill="#2B579A" />
      <text x="12" y="15" fontSize="8" fill="white" textAnchor="middle" fontWeight="bold">
        W
      </text>
    </svg>
  );
}
